import { Box, IconButton, MenuItem } from "@mui/material";
import { materialStatusList } from "../../../client/AllEquipments/CommonFeatures/MCS3/vars";

import DescriptionIcon from "@mui/icons-material/Description";

const mainCols = [
  {
    accessorKey: "time",
    header: "Delivery (in days)",
    Header: () => {
      return (
        <div>
          <div style={{ textAlign: "center" }}>Delivery</div>
          <div style={{ textAlign: "center" }}>(in days)</div>
        </div>
      );
    },
    size: 100,
  },
  {
    accessorKey: "cost",
    header: "Cost / Unit (Dollar$)",
    Header: () => {
      return (
        <div>
          <div style={{ textAlign: "center" }}>Cost / Unit</div>
          <div style={{ textAlign: "center" }}>(Dollar $)</div>
        </div>
      );
    },
    size: 100,
  },

  // {
  //   accessorKey: "status",
  //   header: "Status",
  //   size: 100,
  //   muiEditTextFieldProps: () => ({
  //     children: materialStatusList.map((n) => (
  //       <MenuItem key={n} value={n}>
  //         {n}
  //       </MenuItem>
  //     )),
  //     select: true,
  //   }),
  //   enableEditing: true,
  // },
];
export const taggedCols = (onClickRowDataSheet) => [
  {
    accessorKey: "uids",
    header: "UIDs",
    enableEditing: false,
    size: 100,
    Cell: ({ row }) => {
      // console.log("row", row.original);
      return (
        <Box>
          {row.original.materials?.map((m, i) => {
            return (
              // m.bulkMaterial?.item + ", "
              <p key={i}>- {m.UID || ""}</p>
            );
          })}
        </Box>
      );
    },
  },
  {
    accessorKey: "tagNumber",
    header: "Tag Number",
    size: 400,
    enableEditing: false,

    Cell: ({ row }) => {
      console.log("row", row.original);
      return (
        <Box>
          {row.original.materials?.map((m, i) => {
            return <p key={i}>- {m?.tagNumber || ""} </p>;
          })}
        </Box>
      );
    },
  },
  {
    accessorKey: "description",
    header: "Material Description",

    size: 400,
    enableEditing: false,
  },
  {
    accessorKey: "remarks",
    header: "Remarks",
    size: 200,
    enableEditing: false,
  },

  {
    accessorKey: "procuredQty",
    header: "Quantity",
    size: 50,
    // minWidth: 100,
    enableEditing: false,
  },

  ...mainCols,
  {
    accessorKey: "dataSheet",
    header: "Data Sheet",
    Header: () => {
      return (
        <div>
          <div style={{ textAlign: "center" }}>Data Sheet</div>
          <div style={{ textAlign: "center" }}>(Doc)</div>
        </div>
      );
    },
    size: 100,
    enableEditing: false,
    Cell: ({ row }) => {
      return (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onClickRowDataSheet(row.original);
            }}
          >
            <DescriptionIcon color="primary" />
          </IconButton>
        </Box>
      );
    },
  },
];

export const bulkedCols = (onClickRowDataSheet) => [
  // {
  //   accessorKey: "materialCode",
  //   header: "Material Code",
  // },
  {
    accessorKey: "costCode",
    header: "Cost Code",
    size: 90,
    // minWidth: 100,
    enableEditing: false,
  },
  {
    accessorKey: "description",
    header: "Material Description",
    size: 400,
    enableEditing: false,
  },
  {
    accessorKey: "remarks",
    header: "Remarks",
    size: 200,
    enableEditing: false,
  },

  {
    accessorKey: "procuredQty",
    header: "Quantity",
    size: 50,
    // minWidth: 100,
    enableEditing: false,
  },

  {
    accessorKey: "procuredUnit",
    header: "unit",
    size: 50,
    // minWidth: 100,
    enableEditing: false,
    // Cell: ({ row }) => {
    //   const isPlate = row.original?.description
    //     ?.toLowerCase()
    //     .includes("plate");
    //   const isPipe = row.original?.description?.toLowerCase().includes("pipe");
    //   const isHead = row.original?.costCode?.toLowerCase().includes("head");

    //   console.log({ row });
    //   if (isPlate) {
    //     return "Ft²";
    //   } else if (row.original.unit) {
    //     return row.original.unit;
    //   } else if (isPipe && !isHead) {
    //     return "mm";
    //   } else {
    //     return "Nos";
    //   }
    // },
  },

  ...mainCols,
  {
    accessorKey: "dataSheet",
    header: "Data Sheet",
    Header: () => {
      return (
        <div>
          <div style={{ textAlign: "center" }}>Data Sheet</div>
          <div style={{ textAlign: "center" }}>(Doc)</div>
        </div>
      );
    },
    size: 100,
    enableEditing: false,
    Cell: ({ row }) => {
      return (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onClickRowDataSheet(row.original);
            }}
          >
            <DescriptionIcon color="primary" />
          </IconButton>
        </Box>
      );
    },
  },
];
